/* eslint-disable */
const Cookie = {
    cookieExist: function (cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return true;
        }
        else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;

        }
    },
    getCookieValue: function (cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return match[2];
        }
        else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;

        }

    },
    setCookie: function (cookieName, zipcode) {
        document.cookie = cookieName + '=' + zipcode;
    },
    setPageCookie: function (cName, cValue, expDays) {
        expDays = expDays || 30; // set to 30 days as default
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + ";";
    },
    deleteCookie: function (cookieName) {
        document.cookie = cookieName + '=; ' + 'expires = Thu, 01 Jan 1970 00:00:00 GMT';
    },
    getAllCookies: function () {
        console.log(document.cookie);
    }
};

export { Cookie };



// WEBPACK FOOTER //
// ./src/app/utils/aha-cookie.js